/**
 * Entity-scoped compose refresh — sibling of `refreshTable` for non-table UI.
 *
 * ActionRegistry API cache invalidation lives in `@packages/cache-manager`
 * (`invalidateActionCache`). Use that from action handlers / form submit.
 */

export const ENTITY_REFRESH_EVENT = 'compose:entity-refresh';

export interface EntityRefreshDetail {
  entity: string;
  entityId?: string;
}

/** Entity-scoped refresh signal for keep-alive compose views. Does not clear action caches. */
export function refreshEntityData(entity: string, entityId?: string): void {
  if (!entity) return;
  if (typeof window === 'undefined') return;

  const detail: EntityRefreshDetail = { entity, entityId };
  window.dispatchEvent(new CustomEvent(ENTITY_REFRESH_EVENT, { detail }));
}

export function matchesEntityRefresh(
  detail: EntityRefreshDetail | undefined,
  entityId: string | undefined,
): boolean {
  if (detail == null || !detail.entity) return false;
  if (entityId == null || entityId === '') return false;
  if (detail.entityId != null && detail.entityId !== '' && detail.entityId !== entityId) {
    return false;
  }
  return true;
}

/**
 * @deprecated Use `invalidateActionCache` from `@packages/cache-manager`.
 * Kept as a thin alias so existing call sites keep working during migration.
 */
export { invalidateActionCache as invalidateActions } from '@packages/cache-manager';
